<!--use a s sample to build out new route/child route logic-->
<template>
    <v-main v-if="org">
<!--        <v-card>-->
<!--            <v-card-title>-->
<!--                {{org.info.fullname}} calendar-->
<!--            </v-card-title>-->
<!--        </v-card>-->
        <router-view></router-view>
    </v-main>
</template>

<script>
  const PATH = '/Skeleton' //im lazy and hate writing `"organi....
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        menu: true,
        tiles:[
          {to: PATH+'/route1', icon: 'share', name: 'Keys'},
          {to: PATH+'/route2', icon: 'user', name: 'Users'}
        ],
        activating:false
      }
    },
    computed:{
      ...mapState(['org','icons']),
    },
    mounted() {
    },
    methods: {
      ...mapActions(['get','post','putAppOrg'])
    }
  }
</script>

<style scoped>

</style>